import { apiWrapper } from '../helper/api-wrapper';

export const updateStatusActiveItem = async (payload) => {
  try {
    const response = await apiWrapper.post(`merchants/product/active`, payload);

    return response;
  } catch (error) {
    throw error;
  }
};

export const getItems = async ({
  type = 'all',
  page = 0,
  limit = 2,
  search = '',
  category = 0,
}) => {
  try {
    const response = await apiWrapper.get(
      `merchants/products/lists?type=${type}&offset=${page}&limit=${limit}&query=${search}&category=${category}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const addItems = async (payload, onProgress) => {
  try {
    const response = await apiWrapper.multipartPost(
      `merchants/products/save_json_v4`,
      payload,
      onProgress
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const editItems = async (payload, onProgress) => {
  try {
    const response = await apiWrapper.multipartPatch(
      `merchants/products/update_json_v4`,
      payload,
      onProgress
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteItems = async (payload) => {
  try {
    const response = await apiWrapper.delete(
      `merchants/products/delete/${payload?.id}`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const addVariant = async (payload, onProgress) => {
  try {
    const response = await apiWrapper.multipartPost(
      `merchants/products/detail/save_v4`,
      payload,
      onProgress
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateVariant = async (payload, onProgress) => {
  try {
    const response = await apiWrapper.multipartPost(
      `merchants/products/detail/update_v4`,
      payload,
      onProgress
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const addVariantStock = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/products/stock/update`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteVariant = async (id, payload) => {
  try {
    const response = await apiWrapper.delete(`variant/delete/${id}`, payload);

    return response;
  } catch (error) {
    throw error;
  }
};

export const detailProduct = async (id) => {
  try {
    const response = await apiWrapper.get(`merchants/products/${id}`);

    return response;
  } catch (error) {
    throw error;
  }
};

export const variantList = async (id, search) => {
  try {
    const response = await apiWrapper.get(
      `merchants/products/detail/lists/${id}?search=${search}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const detailVariant = async (id) => {
  try {
    const response = await apiWrapper.get(
      `merchants/products/variance/detail/${id}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getSKU = async (data) => {
  try {
    const response = await apiWrapper.post(
      `merchants/products/variant/generate-sku`,
      data
    );

    return response;
  } catch (error) {
    throw error;
  }
};
